import React, { useEffect, useState, useRef } from 'react';
import Layout from '../Layout';
import OwlCarousel from 'react-owl-carousel';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { IoMdPerson } from "react-icons/io";
import Autocomplete from '../Autocomplete/Autocomplete';
import GoogleMapsLoader from '../Autocomplete/GoogleMapsLoader';
import TransferAutocomplete from '../Autocomplete/TransferAutocomplete';
import config from '../../config';
import { FaMapMarkerAlt, FaHotel, FaBed } from "react-icons/fa";
import { MdOutlineLocalAirport } from "react-icons/md";
import Swal from 'sweetalert2'
import geoService from '../../services/geoService';
import tourService from '../../services/tourService';
import transferService from '../../services/transferService';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MdOutlineTravelExplore } from "react-icons/md";
import { IoCalendarNumberSharp } from "react-icons/io5";
import { FaDirections } from "react-icons/fa";
import { MdOutlineModeOfTravel } from "react-icons/md";
import './First.css';

// Dropdown z-index stilleri
const dropdownStyles = `
.dropdown-menu-custom {
    z-index: 99999 !important;
    position: fixed !important;
}

.personality {
    z-index: 99999 !important;
}

.react-dropdown-select-dropdown {
    z-index: 99999 !important;
}

.react-dropdown-select-content {
    z-index: 99999 !important;
}

.react-dropdown-select-item {
    z-index: 99999 !important;
}

/* Hotel suggestion dropdown fix */
.dropdown-menu-custom {
    position: absolute !important;
    z-index: 99999 !important;
}

/* Basic custom-dropdown styles for other components */
.custom-dropdown .react-dropdown-select-dropdown {
    position: absolute !important;
    z-index: 99999 !important;
    background: white !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;
}

.custom-dropdown .react-dropdown-select-content {
    border: 1px solid #e0e0e0 !important;
    border-radius: 8px !important;
    padding: 10px 15px !important;
}

/* Form container overflow fix */
.banner-form,
.card-body,
.tab-content,
.tab-pane,
.form-info {
    overflow: visible !important;
}

/* Nationality dropdown styles */
.nationality-dropdown .react-dropdown-select-dropdown {
    position: absolute !important;
    top: 100% !important;
    left: 0 !important;
    width: 250px !important;
    margin-top: 5px !important;
    border-radius: 12px !important;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15) !important;
    border: none !important;
    background: white !important;
    z-index: 99999 !important;
}

.nationality-dropdown .react-dropdown-select-item {
    padding: 12px 18px !important;
    cursor: pointer !important;
    border-bottom: 1px solid #f5f7fa !important;
}

.nationality-dropdown .react-dropdown-select-item:hover {
    background-color: #f1f5f9 !important;
    color: #1e3a8a !important;
}

.nationality-dropdown .react-dropdown-select-item:last-child {
    border-bottom: none !important;
}

/* Nationality field styling */
.nationality-dropdown .react-dropdown-select-content {
    border: 2px solid #e8ecf4 !important;
    border-radius: 12px !important;
    padding: 14px 18px !important;
    font-size: 15px !important;
    font-weight: 500 !important;
    background-color: #fff !important;
    min-height: 48px !important;
    height: 48px !important;
    transition: all 0.3s ease !important;
    display: flex !important;
    align-items: center !important;
}

.nationality-dropdown .react-dropdown-select-content:focus {
    border-color: #1e3a8a !important;
    box-shadow: 0 0 0 3px rgba(30, 58, 138, 0.1) !important;
}



/* Google Maps Autocomplete inputs focus effects */
#transfer-pickup:focus,
#transfer-dropoff:focus,
#tour-destination:focus {
    border-color: #1e3a8a !important;
    box-shadow: 0 0 0 3px rgba(30, 58, 138, 0.1) !important;
    outline: none !important;
}

#transfer-pickup:hover,
#transfer-dropoff:hover,
#tour-destination:hover {
    border-color: #3730a3 !important;
}

/* Google Maps suggestions dropdown styling */
.pac-container {
    border-radius: 12px !important;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15) !important;
    border: none !important;
    margin-top: 5px !important;
    background: white !important;
    z-index: 99999 !important;
    max-width: none !important;
    min-width: 300px !important;
}

/* Hide Google logo and remove borders globally */
.pac-container .pac-logo-after,
.pac-container .pac-logo-hdpi,
.pac-container::after {
    display: none !important;
}

.pac-item {
    padding: 12px 18px !important;
    border-bottom: 1px solid #f5f7fa !important;
    cursor: pointer !important;
    font-size: 14px !important;
    line-height: 1.4 !important;
    transition: all 0.2s ease !important;
    border: none !important;
}

.pac-item:hover {
    background-color: #f1f5f9 !important;
    color: #1e3a8a !important;
}

.pac-item-selected {
    background-color: #1e3a8a !important;
    color: white !important;
}

.pac-item:last-child {
    border-bottom: none !important;
}

.pac-item .pac-icon {
    display: none !important;
    visibility: hidden !important;
    width: 0 !important;
    height: 0 !important;
    opacity: 0 !important;
}

.pac-item .pac-item-query {
    font-weight: 600 !important;
    color: #1e3a8a !important;
    font-size: 14px !important;
}

.pac-item-selected .pac-item-query {
    color: white !important;
}

.pac-item .pac-matched {
    font-weight: 600 !important;
}

.pac-item-selected .pac-matched {
    color: white !important;
}

/* Hide Google Maps pac-container for transfer locations - we use our own dropdown */
#transfer-pickup + .pac-container,
#transfer-dropoff + .pac-container {
    display: none !important;
}

/* Tour destination specific styling */
#tour-destination {
    font-family: inherit !important;
}

/* Tour destination dropdown styling - matches hotel destination style */
.pac-container.tour-destination-dropdown {
    border-radius: 12px !important;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15) !important;
    border: none !important;
    margin-top: 5px !important;
    background: white !important;
    z-index: 99999 !important;
    max-width: none !important;
    min-width: 300px !important;
}

/* Remove Google logo and borders */
.pac-container.tour-destination-dropdown .pac-logo-after,
.pac-container.tour-destination-dropdown .pac-logo-hdpi,
.pac-container.tour-destination-dropdown::after {
    display: none !important;
}

.pac-container.tour-destination-dropdown .pac-item {
    padding: 12px 18px !important;
    border-bottom: 1px solid #f5f7fa !important;
    cursor: pointer !important;
    font-size: 14px !important;
    line-height: 1.4 !important;
    transition: all 0.2s ease !important;
    color: #2c3e50 !important;
    border: none !important;
}

.pac-container.tour-destination-dropdown .pac-item:hover {
    background-color: #f1f5f9 !important;
    color: #1e3a8a !important;
}

.pac-container.tour-destination-dropdown .pac-item-selected {
    background-color: #1e3a8a !important;
    color: white !important;
}

.pac-container.tour-destination-dropdown .pac-item:last-child {
    border-bottom: none !important;
}

.pac-container.tour-destination-dropdown .pac-item .pac-icon {
    display: none !important;
    visibility: hidden !important;
    width: 0 !important;
    height: 0 !important;
    opacity: 0 !important;
}

.pac-container.tour-destination-dropdown .pac-item {
    position: relative !important;
    padding-left: 45px !important;
}

.pac-container.tour-destination-dropdown .pac-item::before {
    content: "📍" !important;
    position: absolute !important;
    left: 15px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    font-size: 18px !important;
    color: #1e3a8a !important;
    display: block !important;
    line-height: 1 !important;
    width: 20px !important;
    text-align: center !important;
}

.pac-container.tour-destination-dropdown .pac-item-selected::before {
    color: white !important;
}

.pac-container.tour-destination-dropdown .pac-item .pac-item-query {
    font-weight: 600 !important;
    color: #1e3a8a !important;
    font-size: 14px !important;
}

.pac-container.tour-destination-dropdown .pac-item-selected .pac-item-query {
    color: white !important;
}

.pac-container.tour-destination-dropdown .pac-item .pac-matched {
    font-weight: 600 !important;
    color: #1e3a8a !important;
}

.pac-container.tour-destination-dropdown .pac-item-selected .pac-matched {
    color: white !important;
}

/* React DatePicker Custom Styles */
.custom-datepicker-wrapper .react-datepicker__input-container input {
    border: none !important;
    padding: 0 !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    background-color: transparent !important;
    outline: none !important;
    box-shadow: none !important;
    color: #2c3e50 !important;
    cursor: pointer !important;
    width: 100% !important;
}

.custom-datepicker-wrapper .react-datepicker__input-container input:focus {
    color: #1e3a8a !important;
    border: none !important;
    box-shadow: none !important;
}

.custom-datepicker-popper {
    z-index: 99999 !important;
}

.custom-datepicker {
    border: none !important;
    border-radius: 16px !important;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15) !important;
    font-family: inherit !important;
}

.react-datepicker__header {
    background-color: #1e3a8a !important;
    border-bottom: none !important;
    border-top-left-radius: 16px !important;
    border-top-right-radius: 16px !important;
    padding: 20px !important;
}

.react-datepicker__current-month {
    color: white !important;
    font-weight: 600 !important;
    font-size: 16px !important;
}

.react-datepicker__navigation {
    top: 22px !important;
}

.react-datepicker__navigation--previous {
    border-right-color: white !important;
}

.react-datepicker__navigation--next {
    border-left-color: white !important;
}

.react-datepicker__day-names {
    display: none !important;
}

.react-datepicker__day-name {
    display: none !important;
}

.react-datepicker__day {
    color: #2c3e50 !important;
    font-weight: 500 !important;
    border-radius: 8px !important;
    margin: 2px !important;
    width: 32px !important;
    height: 32px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    transition: all 0.2s ease !important;
}

.react-datepicker__day:hover {
    background-color: #f1f5f9 !important;
    color: #1e3a8a !important;
}

.react-datepicker__day--selected {
    background-color: #1e3a8a !important;
    color: white !important;
    font-weight: 600 !important;
}

.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-range {
    background-color: #e0f2fe !important;
    color: #1e3a8a !important;
}

.react-datepicker__day--range-start,
.react-datepicker__day--range-end {
    background-color: #1e3a8a !important;
    color: white !important;
    font-weight: 600 !important;
}

.react-datepicker__day--disabled {
    color: #cbd5e1 !important;
    cursor: not-allowed !important;
}

.react-datepicker__day--today {
    background-color: #3730a3 !important;
    color: white !important;
    font-weight: 600 !important;
}

.react-datepicker__triangle {
    display: none !important;
}
`;

// Style tag'i head'e ekle
if (typeof document !== 'undefined') {
    const styleElement = document.createElement('style');
    styleElement.textContent = dropdownStyles;
    document.head.appendChild(styleElement);
}

export default function First() {
    const getIcon = (type) => {
        if (type === "locality") return <FaMapMarkerAlt />;
        if (type === "hotel") return <FaHotel />;
        if (type === "lodging") return <FaBed />;
        if (type === "airport") return <MdOutlineLocalAirport />;
        return <FaMapMarkerAlt />; // Varsayılan ikon
    };
    const [selectedLocation, setSelectedLocation] = useState({
        name: "",
        latitude: null,
        longitude: null,
        hotel_code: "",
        formatted_address: "",
    });
    const userData = JSON.parse(localStorage.getItem('user_data')); // Kullanıcı verilerini al
    const [inputValue, setInputValue] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [isSuggestLoading, setIsSuggestLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [Hotels, setHotelList] = useState([]);
    const counterRef = useRef(null);
    const navigate = useNavigate();
    const [countries, setCountries] = useState([]);
    const [selectedDest, setSelectedDest] = useState('Select place');
    const [nation, setNation] = useState('');
    const [nationalityInputValue, setNationalityInputValue] = useState('');
    const [nationalitySuggestions, setNationalitySuggestions] = useState([]);
    const [isNationalitySuggestLoading, setIsNationalitySuggestLoading] = useState(false);
    const nationalityDebounceTimeout = useRef(null);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 700);
    const [selectedPlace, setSelectedPlace] = useState(null);
    const handlePlaceSelected = (place) => {
        setSelectedPlace({
            name: place.name,
            lat: place.lat,
            lng: place.lng,
        });
        localStorage.setItem("place_name", place.name);
        localStorage.setItem("lat", place.lat);
        localStorage.setItem("lng", place.lng);
      };
    
    // Tour form states
    const [tourDestination, setTourDestination] = useState('');
    const [selectedMonths, setSelectedMonths] = useState([]);
    const [monthDropdownOpen, setMonthDropdownOpen] = useState(false);
    const [tourDuration, setTourDuration] = useState('');
    const [selectedTourTypes, setSelectedTourTypes] = useState([]);
    const [tourDurations, setTourDurations] = useState([]);
    const [durationsLoading, setDurationsLoading] = useState(false);
    const [tourTypes, setTourTypes] = useState([]);
    const [tourTypesLoading, setTourTypesLoading] = useState(false);
    const [tourTypesDropdownOpen, setTourTypesDropdownOpen] = useState(false);
    
    // Tour destination state with Google Maps data
    const [tourDestinationLocation, setTourDestinationLocation] = useState({
        name: '',
        formatted_address: '',
        lat: null,
        lng: null,
        place_id: '',
        locationType: ''
    });
    
    // Tour autocomplete states
    const [tourInputValue, setTourInputValue] = useState('');
    const [tourSuggestions, setTourSuggestions] = useState([]);
    const [isTourSuggestLoading, setIsTourSuggestLoading] = useState(false);
    const tourDebounceTimeout = useRef(null);
    
    const monthDropdownRef = useRef(null);
    const tourTypesDropdownRef = useRef(null);
    
    // Transfer form states
    const [transferType, setTransferType] = useState('one-way'); // 'one-way' or 'round-trip'
    const [transferDate, setTransferDate] = useState('');
    const [returnDate, setReturnDate] = useState('');
    const [transferAdults, setTransferAdults] = useState(2);
    const [transferChildren, setTransferChildren] = useState(0);
    const [transferPassengersModal, setTransferPassengersModal] = useState(false);
    const transferPassengersRef = useRef(null);
    
    // Transfer location states with Google Maps data
    const [transferPickupLocation, setTransferPickupLocation] = useState({
        name: '',
        formatted_address: '',
        lat: null,
        lng: null,
        place_id: '',
        locationType: ''
    });
    
    const [transferDropoffLocation, setTransferDropoffLocation] = useState({
        name: '',
        formatted_address: '',
        lat: null,
        lng: null,
        place_id: '',
        locationType: ''
    });
    
    // Transfer location dropdown states
    const [transferPickupInput, setTransferPickupInput] = useState(transferPickupLocation.name || '');
    const [transferDropoffInput, setTransferDropoffInput] = useState(transferDropoffLocation.name || '');
    const [transferPickupSuggestions, setTransferPickupSuggestions] = useState([]);
    const [transferDropoffSuggestions, setTransferDropoffSuggestions] = useState([]);
    const [isTransferPickupLoading, setIsTransferPickupLoading] = useState(false);
    const [isTransferDropoffLoading, setIsTransferDropoffLoading] = useState(false);
    const transferPickupDebounceTimeout = useRef(null);
    const transferDropoffDebounceTimeout = useRef(null);
    const [personalModal, setPersonalModal] = useState(false);
    const [rooms, setRooms] = useState([
        {
            id: 1,
            adultCounter: 2,
            childCounter: 0,
            childrenAges: [],
        },
    ]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (counterRef.current && !counterRef.current.contains(event.target)) {
                setPersonalModal(false);
            }
            if (transferPassengersRef.current && !transferPassengersRef.current.contains(event.target)) {
                setTransferPassengersModal(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Update transfer input values when location changes
    useEffect(() => {
        setTransferPickupInput(transferPickupLocation.name || '');
    }, [transferPickupLocation.name]);

    useEffect(() => {
        setTransferDropoffInput(transferDropoffLocation.name || '');
    }, [transferDropoffLocation.name]);

    // Tab değişikliklerini dinle ve active tab stillerini güncelle
    useEffect(() => {
        const handleTabChange = () => {
            const allTabs = document.querySelectorAll('.nav-link');
            allTabs.forEach(tab => {
                if (tab.classList.contains('active')) {
                    // Active tab stili
                    tab.style.background = 'linear-gradient(135deg, #1e3a8a 0%, #3730a3 100%)';
                    tab.style.color = 'white';
                    tab.style.borderColor = '#1e3a8a';
                    tab.style.boxShadow = '0 2px 8px rgba(30, 58, 138, 0.2)';
                } else {
                    // Inactive tab stili (Coming Soon tab'lar hariç)
                    if (!tab.style.cursor || tab.style.cursor !== 'not-allowed') {
                        tab.style.background = 'rgba(255, 255, 255, 0.8)';
                        tab.style.color = '#64748b';
                        tab.style.borderColor = 'rgba(148, 163, 184, 0.3)';
                        tab.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
                    }
                }
            });
        };

        // Tab değişikliklerini dinle
        const tabElements = document.querySelectorAll('[data-bs-toggle="tab"]');
        tabElements.forEach(tab => {
            tab.addEventListener('shown.bs.tab', handleTabChange);
        });

        // İlk yüklemede de çalıştır
        handleTabChange();

        return () => {
            tabElements.forEach(tab => {
                tab.removeEventListener('shown.bs.tab', handleTabChange);
            });
        };
    }, []);
    const updateRoomCount = (counterType) => {
        setRooms((prevRooms) => {
            const newRooms = counterType === "increment" 
                ? [...prevRooms, {
                    id: prevRooms.length + 1,
                    adultCounter: 2,
                    childCounter: 0,
                    childrenAges: [],
                }]
                : prevRooms.length > 1 
                    ? prevRooms.slice(0, -1)
                    : prevRooms;

            // Save to localStorage
            localStorage.setItem('guest_selection', JSON.stringify({
                rooms: newRooms,
                totalAdults: newRooms.reduce((sum, room) => sum + room.adultCounter, 0),
                totalChildren: newRooms.reduce((sum, room) => sum + room.childCounter, 0)
            }));

            return newRooms;
        });
    };
    const updateRoomCounters = (roomId, type, counterType) => {
        setRooms((prevRooms) => {
            const newRooms = prevRooms.map((room) => {
                if (room.id === roomId) {
                    if (type === "adult") {
                        return {
                            ...room,
                            adultCounter:
                                counterType === "increment"
                                    ? room.adultCounter + 1
                                    : Math.max(1, room.adultCounter - 1),
                        };
                    } else if (type === "child") {
                        const newChildCounter =
                            counterType === "increment"
                                ? room.childCounter + 1
                                : Math.max(0, room.childCounter - 1);

                        const validChildCounter = Math.max(0, newChildCounter);

                        return {
                            ...room,
                            childCounter: validChildCounter,
                            childrenAges: validChildCounter < room.childrenAges.length
                                ? room.childrenAges.slice(0, validChildCounter)
                                : [
                                    ...room.childrenAges,
                                    ...Array(validChildCounter - room.childrenAges.length).fill({ type: 'CH', age: "" }),
                                ],
                        };
                    }
                }
                return room;
            });

            // Save to localStorage
            localStorage.setItem('guest_selection', JSON.stringify({
                rooms: newRooms,
                totalAdults: newRooms.reduce((sum, room) => sum + room.adultCounter, 0),
                totalChildren: newRooms.reduce((sum, room) => sum + room.childCounter, 0)
            }));

            return newRooms;
        });
    };
    const handleChildAgeChange = (roomId, index, value) => {
        setRooms((prevRooms) => {
            const newRooms = prevRooms.map((room) => {
                if (room.id === roomId) {
                    const updatedAges = [...room.childrenAges];
                    updatedAges[index] = { age: Number(value) };
                    return { ...room, childrenAges: updatedAges };
                }
                return room;
            });

            // Save to localStorage
            localStorage.setItem('guest_selection', JSON.stringify({
                rooms: newRooms,
                totalAdults: newRooms.reduce((sum, room) => sum + room.adultCounter, 0),
                totalChildren: newRooms.reduce((sum, room) => sum + room.childCounter, 0)
            }));

            return newRooms;
        });
    };
    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const data = await geoService.getCountries();
                setCountries(data);
            } catch (error) {
                console.error('Error fetching countries:', error);
            }
        };
    
        fetchCountries();
    }, []);

    useEffect(() => {
        const fetchTourDurations = async () => {
            try {
                setDurationsLoading(true);
                const data = await tourService.getTourDurations();
                console.log('Fetched tour durations:', data); // Debug için
                
                // Data'nın array olduğundan emin ol
                if (Array.isArray(data)) {
                    setTourDurations(data);
                } else {
                    console.error('Tour durations data is not an array:', data);
                    setTourDurations([]);
                }
            } catch (error) {
                console.error('Error fetching tour durations:', error);
                // Hata durumunda boş array kullan (API'den gelen data format'ına uygun)
                setTourDurations([]);
            } finally {
                setDurationsLoading(false);
            }
        };

        const fetchTourTypes = async () => {
            try {
                setTourTypesLoading(true);
                const data = await tourService.getTourTypes();
                console.log('Fetched tour types:', data); // Debug için
                
                // Data'nın array olduğundan emin ol
                if (Array.isArray(data)) {
                    setTourTypes(data);
                } else {
                    console.error('Tour types data is not an array:', data);
                    setTourTypes([]);
                }
            } catch (error) {
                console.error('Error fetching tour types:', error);
                // Hata durumunda boş array kullan
                setTourTypes([]);
            } finally {
                setTourTypesLoading(false);
            }
        };

        fetchTourDurations();
        fetchTourTypes();
    }, []);

    useEffect(() => {
        const today = new Date();
        today.setDate(today.getDate() + 1);
        const formattedToday = today.toISOString().split('T')[0];

        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);
        const formattedTomorrow = tomorrow.toISOString().split('T')[0];
        setStartDate(formattedToday);
        setEndDate(formattedTomorrow);
        setTransferDate(formattedToday);
        setReturnDate(formattedTomorrow);
        localStorage.setItem('start_date',formattedToday);
        localStorage.setItem('end_date',formattedTomorrow);

        const handleResize = () => {
          setIsMobile(window.innerWidth <= 700);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
/* 
    const handleCounterChange = (type, field) => {
        if (field === "adult") {
            setAdultCounter((prev) => {
                if (type === "increment") {
                    setTotalCounter(adultCounter + child1Counter + child2Counter + 1);
                    return prev + 1;
                } else if (type === "decrement") {
                    if(prev > 1)
                    {
                        setTotalCounter(adultCounter + child1Counter + child2Counter - 1);
                        return prev-1;
                    }else
                    {
                        return 1;
                    }
                }
                return prev;
            });
        } else if (field === "child1") {
            setChild1Counter((prev) => {
                if (type === "increment") {
                    setTotalCounter(adultCounter + child2Counter + child1Counter+1);
                    return prev + 1;
                } else if (type === "decrement") {
                    if(prev > 0)
                    {
                        setTotalCounter(adultCounter + child2Counter + child1Counter - 1);
                        return prev - 1;
                    }
                    else
                    {
                        return 0;
                    }
                }
                return prev;
            });
        } else if (field === "child2") {
            setChild2Counter((prev) => {
                if (type === "increment") {
                    setTotalCounter(adultCounter + child1Counter + child2Counter +1);
                    return prev + 1;
                } else if (type === "decrement") {
                    if(prev > 0)
                    {
                        setTotalCounter(adultCounter + child2Counter + childCounter - 1);
                        return prev - 1;
                    }
                    else
                    {
                        return 0;
                    }
                }
                return prev;
            });
        } else if (field === "room") {
            setRoomCounter((prev) => {
                if (type === "increment") {
                    return prev + 1;
                } else if (type === "decrement") {
                    return prev > 1 ? prev - 1 : 1; // Minimum 1 kontrolü
                }
                return prev;
            });
        }
    }; */
    const options = {
        items: 1, 
        loop: true,
        autoplay: true,
        nav: false, 
        dots: true,
    };
    const handleInputChange = (e) => {
        setSelectedDest(e.target.value); // Input değiştikçe state'i günceller
    };
    // İki konum arasındaki mesafeyi Haversine formülü ile hesaplayan fonksiyon
    function getDistance(lat1, lng1, lat2, lng2) {
        const R = 6371; // Dünya'nın yarıçapı (km cinsinden)
        const dLat = deg2rad(lat2 - lat1);
        const dLng = deg2rad(lng2 - lng1);
        const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) *
            Math.cos(deg2rad(lat2)) *
            Math.sin(dLng / 2) *
            Math.sin(dLng / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c; // Sonuç kilometre cinsinden
    }
    // Dereceyi radyana çeviren yardımcı fonksiyon
    function deg2rad(deg) {
        return deg * (Math.PI / 180);
    }
    // Benzerlik skoru hesaplayan fonksiyon
    function getSimilarityScore(str1, str2) {
        const longer = str1.length > str2.length ? str1 : str2;
        const shorter = str1.length > str2.length ? str2 : str1;
    
        const longerLength = longer.length;
        if (longerLength === 0) {
        return 1.0; // İki boş string aynı kabul edilir
        }
        return (longerLength - getEditDistance(longer, shorter)) / parseFloat(longerLength);
    }
    // Edit distance hesaplayan fonksiyon (Levenshtein distance)
    function getEditDistance(str1, str2) {
        const tmp = [];
        let i, j,
        l1 = str1.length,
        l2 = str2.length,
        al = l1 + 1,
        bl = l2 + 1;
    
        for (i = 0; i < al; i++) tmp[i] = [i];
        for (j = 0; j < bl; j++) tmp[0][j] = j;
    
        for (i = 1; i < al; i++) {
        for (j = 1; j < bl; j++) {
            tmp[i][j] =
            str1[i - 1] === str2[j - 1]
                ? tmp[i - 1][j - 1]
                : Math.min(
                    tmp[i - 1][j - 1] + 1,
                    Math.min(tmp[i][j - 1] + 1, tmp[i - 1][j] + 1)
                );
        }
        }
        return tmp[l1][l2];
    }
    // Dereceyi radyana çeviren yardımcı fonksiyon
    function deg2rad(deg) {
        return deg * (Math.PI / 180);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!selectedPlace) {
            // Eğer selectedPlace boşsa, en yakın yeri seç
            if (suggestions.length > 0) {
                let closestPlace = suggestions[0];
                let closestDistance = getDistance(
                    parseFloat(localStorage.getItem("lat")),
                    parseFloat(localStorage.getItem("lng")),
                    closestPlace.latitude,
                    closestPlace.longitude
                );
                suggestions.forEach((suggestion) => {
                    const distance = getDistance(
                        parseFloat(localStorage.getItem("lat")),
                        parseFloat(localStorage.getItem("lng")),
                        suggestion.latitude,
                        suggestion.longitude
                    );
                    if (distance < closestDistance) {
                        closestPlace = suggestion;
                        closestDistance = distance;
                    }
                });
                setSelectedPlace({
                    name: closestPlace.name,
                    lat: closestPlace.latitude,
                    lng: closestPlace.longitude,
                    hotel_code: closestPlace.hotel_code || "",
                });
                localStorage.setItem("place_name", closestPlace.name);
                localStorage.setItem("lat", closestPlace.latitude);
                localStorage.setItem("lng", closestPlace.longitude);
                localStorage.setItem("hotel_code", closestPlace.hotel_code || '');
            } else {
                Swal.fire({
                    title: "Please select the destination!",
                    icon: "info",
                    draggable: true,
                });
                return;
            }
        }
        if(!endDate) {
            Swal.fire({
                title: "Please select the check-out date!",
                icon: "info",
                draggable: true,
            });
            return;
        }
        if(!nation) {
            Swal.fire({
                title: "Please select the nationality!",
                icon: "info",
                draggable: true,
            });
            return;
        }
        setLoading(true);

        const params = new URLSearchParams();
        params.set('checkIn', startDate);
        params.set('checkOut', endDate);
        params.set('nation', nation);
        params.set('lat', selectedPlace ? selectedPlace.lat : localStorage.getItem("lat"));
        params.set('lng', selectedPlace ? selectedPlace.lng : localStorage.getItem("lng"));
        
        // Konum bilgilerini ekle
        if (selectedLocation.hotel_code) {
            params.set('hotel_code', selectedLocation.hotel_code);
        }
        params.set('locationName', selectedLocation.name || selectedPlace.name);
        // Occupancies bilgisini düzelt
        const occupancies = rooms.map(room => ({
            rooms: 1,
            adults: room.adultCounter,
            children: room.childCounter,
            paxes: room.childrenAges.map(child => ({
                type: "CH",
                age: child.age === "" ? 0 : Number(child.age)
            }))
        }));
        console.log('OCC: ', occupancies);
        params.set('occupancies', JSON.stringify(occupancies));
        navigate(`/hotels?${params.toString()}`);
        window.scrollTo(0, 0);
    };

    const handleChange = (values) => {
        if (values.length > 0) {
            localStorage.setItem('nation',values[0].iso2);
            setNation(values[0].iso2); // Seçilen değeri güncelle.
        }
    };
    
    // Nationality autocomplete functions
    const fetchNationalitySuggestions = async (searchText) => {
        setIsNationalitySuggestLoading(true);
        try {
            // Ülkeleri filtrele
            const filtered = countries.filter(country => 
                country.name.toLowerCase().includes(searchText.toLowerCase())
            );
            setNationalitySuggestions(filtered.slice(0, 10));
        } catch (error) {
            console.error("Error filtering nationality suggestions:", error);
            setNationalitySuggestions([]);
        } finally {
            setIsNationalitySuggestLoading(false);
        }
    };
    
    const handleNationalityInputChange = (e) => {
        const value = e.target.value;
        setNationalityInputValue(value);
        
        // Eğer kullanıcı bir şey yazmazsa önerileri temizle
        if (value.length < 2) {
            setNationalitySuggestions([]);
            return;
        }
        
        // Önceki timeout'u temizle
        if (nationalityDebounceTimeout.current) {
            clearTimeout(nationalityDebounceTimeout.current);
        }
        
        // Yeni bir timeout başlat
        nationalityDebounceTimeout.current = setTimeout(() => {
            fetchNationalitySuggestions(value);
        }, 200);
    };
    
    const handleNationalitySuggestionClick = (suggestion) => {
        console.log('Nationality suggestion:', suggestion);
        setNation(suggestion.iso2);
        setNationalityInputValue(suggestion.name);
        localStorage.setItem('nation', suggestion.iso2);
        setNationalitySuggestions([]); // Dropdown'u kapat
    };
    const fetchSuggestions = async (searchText) => {
        setIsSuggestLoading(true);
        try {
            const data = await geoService.getAutoComplete(searchText);
            setSuggestions(data.slice(0, 10));
        } catch (error) {
            console.error("Error fetching suggestions:", error);
            setSuggestions([]);
        } finally {
            setIsSuggestLoading(false);
        }
    };
    const handleSuggestInputChange = (e) => {
        const value = e.target.value;
        console.log('value: ', value);
        setInputValue(value);
    
        // Eğer kullanıcı bir şey yazmazsa önerileri temizle
        if (value.length < 3) {
            setSuggestions([]);
            return;
        }
    
        // Önceki timeout'u temizle
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }
    
        // Yeni bir timeout başlat
        debounceTimeout.current = setTimeout(() => {
            fetchSuggestions(value);
        }, 200); 
    };
    const handleSuggestionClick = (suggestion) => {
        console.log('suggestion:' , suggestion);
        setSelectedLocation({
            name: suggestion.name,
            latitude: suggestion.latitude,
            longitude: suggestion.longitude,
            hotel_code: suggestion.hotel_code || "", // hotelbeds_code yoksa boş bırak
            formatted_address: suggestion.formatted_address || "", // formatted_address yoksa boş bırak
        });
        setSelectedPlace({
            name: suggestion.name,
            lat: suggestion.latitude,
            lng: suggestion.longitude,
            hotel_code: suggestion.hotel_code || "",
        });
        localStorage.setItem("place_name", suggestion.name);
        localStorage.setItem("lat", suggestion.latitude);
        localStorage.setItem("lng", suggestion.longitude);
        localStorage.setItem("hotel_code", suggestion.hotel_code || '');
        setInputValue(suggestion.name); // Input alanını seçilen isimle güncelle
        setSuggestions([]); // Dropdown'u kapat
    };
    console.log('selectedLocation : ', selectedLocation);
    const debounceTimeout = useRef(null);
    
    // Tour autocomplete functions
    const fetchTourSuggestions = async (searchText) => {
        setIsTourSuggestLoading(true);
        try {
            const data = await tourService.getTourAutoComplete(searchText);
            setTourSuggestions(data.slice(0, 10));
        } catch (error) {
            console.error("Error fetching tour suggestions:", error);
            setTourSuggestions([]);
        } finally {
            setIsTourSuggestLoading(false);
        }
    };
    
    const handleTourInputChange = (e) => {
        const value = e.target.value;
        setTourInputValue(value);
        
        // Eğer kullanıcı bir şey yazmazsa önerileri temizle
        if (value.length < 3) {
            setTourSuggestions([]);
            return;
        }
        
        // Önceki timeout'u temizle
        if (tourDebounceTimeout.current) {
            clearTimeout(tourDebounceTimeout.current);
        }
        
        // Yeni bir timeout başlat
        tourDebounceTimeout.current = setTimeout(() => {
            fetchTourSuggestions(value);
        }, 300);
    };
    
    const handleTourSuggestionClick = (suggestion) => {
        console.log('Tour suggestion:', suggestion);
        setTourDestinationLocation({
            name: suggestion.name,
            formatted_address: suggestion.formatted_address || '',
            lat: suggestion.latitude || null,
            lng: suggestion.longitude || null,
            place_id: suggestion.id || '',
            locationType: 'destination'
        });
        setTourDestination(suggestion.name);
        setTourInputValue(suggestion.name); // Input alanını seçilen isimle güncelle
        setTourSuggestions([]); // Dropdown'u kapat
    };
    
    // Ay isimleri ve ay seçimi fonksiyonları
    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    
    const getCurrentAndRemainingMonths = () => {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth();
        const currentYear = currentDate.getFullYear();
        const months = [];
        
        // Bu aydan yıl sonuna kadar
        for (let i = currentMonth; i < 12; i++) {
            months.push({
                index: i,
                name: monthNames[i],
                year: currentYear,
                value: `${currentYear}-${String(i + 1).padStart(2, '0')}`
            });
        }
        
        return months;
    };
    
    const availableMonths = getCurrentAndRemainingMonths();
    
    const handleMonthToggle = (monthValue) => {
        setSelectedMonths(prev => {
            const isSelected = prev.includes(monthValue);
            if (isSelected) {
                return prev.filter(m => m !== monthValue);
            } else {
                return [...prev, monthValue].sort();
            }
        });
    };

    const handleTourTypeToggle = (tourType) => {
        setSelectedTourTypes(prev => {
            const isSelected = prev.some(selected => selected.id === tourType.id);
            if (isSelected) {
                return prev.filter(selected => selected.id !== tourType.id);
            } else {
                return [...prev, tourType];
            }
        });
    };
    
    const handleTourSubmit = (e) => {
        e.preventDefault();
        
        // Destination kontrolü
        if (!tourDestinationLocation.name && !tourDestination) {
            Swal.fire({
                title: "Please select tour destination!",
                icon: "info",
                draggable: true,
            });
            return;
        }
        
        // API request için parametreleri hazırla
        const selectedTypeIds = selectedTourTypes.map(type => type.id);
        
        const apiRequestParams = {
            page: 1,
            perPage: 10,
            search: tourDestinationLocation.name || tourDestination,
            period: selectedMonths, // Array formatında
            duration: tourDuration || "single", // Duration slug
            tourTypeIds: selectedTypeIds, // Tour type IDs array (integer)
            coordinates: {
                latitude: tourDestinationLocation.lat || null,
                longitude: tourDestinationLocation.lng || null
            }
        };
        
        console.log('Tour Search API Request:', apiRequestParams);
        
        // URL parametreleri için serialize et
        const params = new URLSearchParams();
        if (apiRequestParams.search) {
            params.set('search', apiRequestParams.search);
        }
        if (apiRequestParams.coordinates.latitude) {
            params.set('lat', apiRequestParams.coordinates.latitude);
        }
        if (apiRequestParams.coordinates.longitude) {
            params.set('lng', apiRequestParams.coordinates.longitude);
        }
        if (apiRequestParams.period.length > 0) {
            params.set('period', apiRequestParams.period.join(','));
        }
        if (apiRequestParams.duration) {
            params.set('duration', apiRequestParams.duration);
        }
        if (apiRequestParams.tourTypeIds.length > 0) {
            params.set('tourTypeIds', apiRequestParams.tourTypeIds.join(','));
        }
        
        // Tour list sayfasına yönlendir
        navigate(`/tours?${params.toString()}`);
        window.scrollTo(0, 0);
    };



    // Transfer location dropdown functions
    const fetchTransferLocationSuggestions = async (searchText) => {
        try {
            const data = await geoService.getAutoComplete(searchText);
            return data.slice(0, 10);
        } catch (error) {
            console.error("Error fetching transfer location suggestions:", error);
            return [];
        }
    };

    const handleTransferPickupInputChange = (e) => {
        const value = e.target.value;
        setTransferPickupInput(value);
        
        if (value.length < 3) {
            setTransferPickupSuggestions([]);
            return;
        }
        
        if (transferPickupDebounceTimeout.current) {
            clearTimeout(transferPickupDebounceTimeout.current);
        }
        
        transferPickupDebounceTimeout.current = setTimeout(async () => {
            setIsTransferPickupLoading(true);
            const suggestions = await fetchTransferLocationSuggestions(value);
            setTransferPickupSuggestions(suggestions);
            setIsTransferPickupLoading(false);
        }, 300);
    };

    const handleTransferDropoffInputChange = (e) => {
        const value = e.target.value;
        setTransferDropoffInput(value);
        
        if (value.length < 3) {
            setTransferDropoffSuggestions([]);
            return;
        }
        
        if (transferDropoffDebounceTimeout.current) {
            clearTimeout(transferDropoffDebounceTimeout.current);
        }
        
        transferDropoffDebounceTimeout.current = setTimeout(async () => {
            setIsTransferDropoffLoading(true);
            const suggestions = await fetchTransferLocationSuggestions(value);
            setTransferDropoffSuggestions(suggestions);
            setIsTransferDropoffLoading(false);
        }, 300);
    };

    const handleTransferPickupSuggestionClick = (suggestion) => {
        setTransferPickupLocation({
            name: suggestion.name,
            formatted_address: suggestion.formatted_address || '',
            lat: suggestion.latitude,
            lng: suggestion.longitude,
            place_id: suggestion.id || '',
            locationType: 'pickup'
        });
        setTransferPickupInput(suggestion.name);
        setTransferPickupSuggestions([]);
        console.log('Transfer pickup location selected:', suggestion);
    };

    const handleTransferDropoffSuggestionClick = (suggestion) => {
        setTransferDropoffLocation({
            name: suggestion.name,
            formatted_address: suggestion.formatted_address || '',
            lat: suggestion.latitude,
            lng: suggestion.longitude,
            place_id: suggestion.id || '',
            locationType: 'dropoff'
        });
        setTransferDropoffInput(suggestion.name);
        setTransferDropoffSuggestions([]);
        console.log('Transfer dropoff location selected:', suggestion);
    };

    // Transfer form functions
    const handleTransferPickupSelected = (placeData) => {
        setTransferPickupLocation(placeData);
        console.log('Transfer pickup location selected:', placeData);
    };

    const handleTransferDropoffSelected = (placeData) => {
        setTransferDropoffLocation(placeData);
        console.log('Transfer dropoff location selected:', placeData);
    };

    const handleTransferSubmit = async (e) => {
        e.preventDefault();
        
        if (!transferPickupLocation.name) {
            Swal.fire({
                title: "Please select pickup location!",
                icon: "info",
                draggable: true,
            });
            return;
        }
        
        if (!transferDropoffLocation.name) {
            Swal.fire({
                title: "Please select dropoff location!",
                icon: "info",
                draggable: true,
            });
            return;
        }
        
        if (!transferDate) {
            Swal.fire({
                title: "Please select transfer date!",
                icon: "info",
                draggable: true,
            });
            return;
        }
        
        if (transferType === 'round-trip' && !returnDate) {
            Swal.fire({
                title: "Please select return date!",
                icon: "info",
                draggable: true,
            });
            return;
        }

        // Koordinat kontrolü
        if (!transferPickupLocation.lat || !transferPickupLocation.lng) {
            Swal.fire({
                title: "Invalid pickup location!",
                text: "Please select a valid pickup location from the suggestions.",
                icon: "warning",
                draggable: true,
            });
            return;
        }

        if (!transferDropoffLocation.lat || !transferDropoffLocation.lng) {
            Swal.fire({
                title: "Invalid dropoff location!",
                text: "Please select a valid dropoff location from the suggestions.",
                icon: "warning",
                draggable: true,
            });
            return;
        }
        
        // Loading durumu göster
        setLoading(true);
        
        try {
            // API için parametreleri hazırla
            const searchParams = {
                transferType: transferType,
                fromCoordinates: {
                    lat: transferPickupLocation.lat,
                    lng: transferPickupLocation.lng
                },
                toCoordinates: {
                    lat: transferDropoffLocation.lat,
                    lng: transferDropoffLocation.lng
                },
                departureDate: transferDate,
                returnDate: transferType === 'round-trip' ? returnDate : null,
                adults: transferAdults,
                children: transferChildren
            };

            console.log('Transfer Search Params:', searchParams);

            // API çağrısı yap
            const transferResults = await transferService.searchTransfers(searchParams);
            
            // URL parametrelerini hazırla
            const urlParams = new URLSearchParams();
            urlParams.set('type', transferType);
            urlParams.set('pickup', transferPickupLocation.name);
            urlParams.set('dropoff', transferDropoffLocation.name);
            urlParams.set('pickupLat', transferPickupLocation.lat);
            urlParams.set('pickupLng', transferPickupLocation.lng);
            urlParams.set('dropoffLat', transferDropoffLocation.lat);
            urlParams.set('dropoffLng', transferDropoffLocation.lng);
            urlParams.set('pickupType', transferPickupLocation.locationType);
            urlParams.set('dropoffType', transferDropoffLocation.locationType);
            urlParams.set('date', transferDate);
            if (transferType === 'round-trip') urlParams.set('returnDate', returnDate);
            urlParams.set('adults', transferAdults);
            urlParams.set('children', transferChildren);
            
            // Transfer sayfasına yönlendir ve API sonuçlarını state ile gönder
            navigate(`/transfers?${urlParams.toString()}`, {
                state: {
                    transferResults: transferResults,
                    searchParams: searchParams
                }
            });
            
            window.scrollTo(0, 0);
            
        } catch (error) {
            console.error('Transfer search error:', error);
            
            Swal.fire({
                title: "Search Error",
                text: error.message || "An error occurred while searching transfers. Please try again.",
                icon: "error",
                draggable: true,
            });
        } finally {
            setLoading(false);
        }
    };
    
    // Ay dropdown dışında tıklanınca kapatma
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (monthDropdownRef.current && !monthDropdownRef.current.contains(event.target)) {
                setMonthDropdownOpen(false);
            }
            if (tourTypesDropdownRef.current && !tourTypesDropdownRef.current.contains(event.target)) {
                setTourTypesDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    
    if(loading)
    {
    return (
        <div id="loader-wrapper">
            <div id="loader">
                <span className="loader-line"></span>
            </div>
        </div>
        )
    }
return (
    <section className="hero-section">
        <OwlCarousel className={`banner-slider banner-sec owl-carousel ${isMobile ? 'mobile' : ''}`} {...options}>
            <div className="slider-img">
                <img src="/assets/img/banner/banner-d.jpg" alt="Img" onContextMenu={(e) => e.preventDefault()} onDragStart={(e) => e.preventDefault()} />
            </div>
            <div className="slider-img">
                <img src="/assets/img/banner/banner-b.jpg" alt="Img" onContextMenu={(e) => e.preventDefault()} onDragStart={(e) => e.preventDefault()} />
            </div>
            <div className="slider-img">
                <img src="/assets/img/banner/banner-a.jpg" alt="Img" onContextMenu={(e) => e.preventDefault()} onDragStart={(e) => e.preventDefault()} />
            </div>
            <div className="slider-img">
                <img src="/assets/img/banner/banner-c.jpg" alt="Img" onContextMenu={(e) => e.preventDefault()} onDragStart={(e) => e.preventDefault()} />
            </div>
        </OwlCarousel>
        <div className="container">
            <div className="hero-content">
                <div className="row align-items-center">
                    <div className="col-md-12 wow fadeInUp mx-auto" data-wow-delay="0.3s">
                        <div className="banner-content mx-auto">
                            <h1 className="display-5 mb-2 text-white">Get Closer to the Dream: <span>Your
                                    Tour</span>
                                Essentials
                                Await</h1>
                            <h6 className="text-light mx-auto">Your ultimate destination for all things help you
                                celebrate &
                                remember tour experience.</h6>
                        </div>
                        <div className="banner-form card mb-0">
                            <div className="card-header">
                                <ul className="nav tab-nav">
                                   {/*  <li style={{ margin: '2px' }}>
                                        <a href="javascript:void(0);" 
                                           className="nav-link active" 
                                           data-bs-toggle="tab"
                                           data-bs-target="#Hotels"
                                           style={{
                                               background: 'linear-gradient(135deg, #1e3a8a 0%, #3730a3 100%)',
                                               borderRadius: '10px',
                                               color: 'white',
                                               padding: '8px 15px',
                                               fontWeight: '600',
                                               fontSize: '13px',
                                               border: '2px solid #1e3a8a',
                                               transition: 'all 0.3s ease',
                                               display: 'flex',
                                               alignItems: 'center',
                                               gap: '6px',
                                               minWidth: '100px',
                                               justifyContent: 'center',
                                               textDecoration: 'none',
                                               boxShadow: '0 2px 8px rgba(30, 58, 138, 0.2)'
                                           }}
                                           onMouseEnter={(e) => {
                                               if (e.target.classList.contains('active')) {
                                                   // Active tab hover
                                                   e.target.style.background = 'linear-gradient(135deg, #0f2454 0%, #1e1b4b 100%)';
                                                   e.target.style.transform = 'translateY(-2px)';
                                                   e.target.style.boxShadow = '0 12px 35px rgba(30, 58, 138, 0.4)';
                                               }
                                           }}
                                           onMouseLeave={(e) => {
                                               if (e.target.classList.contains('active')) {
                                                   // Active tab normal state
                                                   e.target.style.background = 'linear-gradient(135deg, #1e3a8a 0%, #3730a3 100%)';
                                                   e.target.style.transform = 'translateY(0)';
                                                   e.target.style.boxShadow = '0 2px 8px rgba(30, 58, 138, 0.2)';
                                               }
                                           }}>
                                            <i className="isax isax-buildings5" style={{ fontSize: '16px' }}></i>
                                            Hotels
                                        </a>
                                    </li> */}


                                    <li>
                                        <a
                                            href="javascript:void(0);"
                                            className="nav-link tab-nav-link active"
                                            data-bs-toggle="tab"
                                            data-bs-target="#Hotels2"
                                        >
                                            <i className="isax isax-buildings5" style={{ fontSize: '16px' }}></i>
                                            Hotels
                                        </a>
                                    </li>

                                        <li>
                                        <a
                                            href="javascript:void(0);"
                                            className="nav-link tab-nav-link"
                                            data-bs-toggle="tab"
                                            data-bs-target="#Tour"
                                        >
                                            <MdOutlineModeOfTravel style={{ fontSize: '16px' }} />
                                            Tour
                                        </a>
                                    </li>

                                    <li>
                                        <a
                                            href="javascript:void(0);"
                                            className="nav-link tab-nav-link"
                                            data-bs-toggle="tab"
                                            data-bs-target="#Transfer"
                                        >
                                            <FaDirections />
                                            Transfer
                                        </a>
                                    </li>


                                   
                                    {/*
                                    <li style={{ margin: '2px' }}>
                                        <a href="javascript:void(0);" 
                                           className="nav-link" 
                                           data-bs-toggle="tab"
                                           data-bs-target="#Cars"
                                           style={{
                                               background: 'rgba(255, 255, 255, 0.5)',
                                               borderRadius: '10px',
                                               color: '#94a3b8',
                                               padding: '8px 15px',
                                               fontWeight: '600',
                                               fontSize: '13px',
                                               border: '2px solid rgba(148, 163, 184, 0.2)',
                                               transition: 'all 0.3s ease',
                                               display: 'flex',
                                               alignItems: 'center',
                                               gap: '6px',
                                               minWidth: '100px',
                                               justifyContent: 'center',
                                               textDecoration: 'none',
                                               opacity: '0.7',
                                               cursor: 'not-allowed'
                                           }}>
                                                                                         <i className="isax isax-car5" style={{ fontSize: '16px' }}></i>
                                            Cars
                                        </a>
                                    </li>
                                    <li style={{ margin: '2px' }}>
                                        <a href="javascript:void(0);" 
                                           className="nav-link" 
                                           data-bs-toggle="tab"
                                           data-bs-target="#Cruise"
                                           style={{
                                               background: 'rgba(255, 255, 255, 0.5)',
                                               borderRadius: '10px',
                                               color: '#94a3b8',
                                               padding: '8px 15px',
                                               fontWeight: '600',
                                               fontSize: '13px',
                                               border: '2px solid rgba(148, 163, 184, 0.2)',
                                               transition: 'all 0.3s ease',
                                               display: 'flex',
                                               alignItems: 'center',
                                               gap: '6px',
                                               minWidth: '100px',
                                               justifyContent: 'center',
                                               textDecoration: 'none',
                                               opacity: '0.7',
                                               cursor: 'not-allowed'
                                           }}>
                                            <i className="isax isax-ship5" style={{ fontSize: '16px' }}></i>
                                            Cruise
                                        </a>
                                    </li> */}
                                </ul>
                            </div>

                            


                            <div className="card-body">
                                <div>
                                    <div className="tab-content">
                                      
                                        <div className="tab-pane fade active show" id="Hotels2" style={{ padding: '0px' }}>

                                            <div className="d-flex flex-column" style={{ padding: '0px', textAlign: 'start', marginTop: '10px' }}>
                                                <span className="text-muted" style={{ fontSize: '14px', fontWeight: 'bold', textAlign: 'start', paddingInline: '15px', backgroundColor: 'white', textAlign: 'start' }}>Book Hotel - Villas, Apartments & more.</span>
                                            </div>

                                            <form onSubmit={handleSubmit}>
                                                <div className="d-flex flex-column">
                                                    <div className={`d-flex form-info ${isMobile ? 'mobile' : 'desktop'}`}>
                                                            <div className="form-item dropdown">
                                                            <div className="form-container">
                                                                <div className="form-icon">
                                                                    <MdOutlineTravelExplore />
                                                                </div>
                                                                
                                                                <div className="form-content">
                                                                    <label className="form-label">
                                                                        Destination & Hotel
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Where would you like to go?"
                                                                        value={inputValue}
                                                                        onChange={handleSuggestInputChange}
                                                                        className="form-control"
                                                                        style={{
                                                                            fontSize: '14px',
                                                                            fontWeight: '500',
                                                                            backgroundColor: '#fff',
                                                                            transition: 'all 0.3s ease',
                                                                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
                                                                        }}
                                                                    />
                                                                    
                                                                    {isSuggestLoading && (
                                                                        <div className="loading-container">
                                                                            <i className="isax isax-loading spin me-2"></i>
                                                                            Searching...
                                                                        </div>
                                                                    )}
                                                                    {suggestions.length > 0 && (
                                                                        <ul className="dropdown-menu-custom">
                                                                            {suggestions.map((suggestion, index) => (
                                                                                <li
                                                                                    key={index}
                                                                                    onClick={() => handleSuggestionClick(suggestion)}
                                                                                    className="dropdown-item-custom"
                                                                                >
                                                                                    <span style={{ color: '#1e3a8a', fontSize: '16px' }}>
                                                                                        {getIcon(suggestion.type)}
                                                                                    </span>
                                                                                    {suggestion.name}
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="form-item" style={{ 
                                                            minWidth: '320px',
                                                            position: 'relative'
                                                        }}>
                                                            <div 
                                                                className="date-range-container"
                                                            >
                                                                {/* Sol taraf - Calendar Icon */}
                                                                <div className="form-icon">
                                                                    <IoCalendarNumberSharp />
                                                                </div>
                                                                
                                                                {/* Sağ taraf - Label ve Date Range */}
                                                                <div className="form-content">
                                                                    <label className="form-label">
                                                                        Check In - Check Out
                                                                    </label>
                                                                    
                                                                    {/* Date Range Container */}
                                                                    <div>
                                                                        <DatePicker
                                                                            onChange={(dates) => {
                                                                                if (Array.isArray(dates)) {
                                                                                    const [start, end] = dates;
                                                                                    console.log('Date selection:', { start, end });
                                                                                    
                                                                                    if (start) {
                                                                                        // Timezone-safe formatting
                                                                                        const year = start.getFullYear();
                                                                                        const month = String(start.getMonth() + 1).padStart(2, '0');
                                                                                        const day = String(start.getDate()).padStart(2, '0');
                                                                                        const formattedStart = `${year}-${month}-${day}`;
                                                                                        setStartDate(formattedStart);
                                                                                        setEndDate(null);
                                                                                        localStorage.setItem('start_date', formattedStart);
                                                                                    }
                                                                                    
                                                                                    if (end) {
                                                                                        // Timezone-safe formatting
                                                                                        const year = end.getFullYear();
                                                                                        const month = String(end.getMonth() + 1).padStart(2, '0');
                                                                                        const day = String(end.getDate()).padStart(2, '0');
                                                                                        const formattedEnd = `${year}-${month}-${day}`;
                                                                                        setEndDate(formattedEnd);
                                                                                        localStorage.setItem('end_date', formattedEnd);
                                                                                    } else {
                                                                                        // End date'i temizle eğer sadece start seçildiyse
                                                                                        setEndDate('');
                                                                                        localStorage.setItem('end_date', '');
                                                                                    }
                                                                                }
                                                                            }}
                                                                            startDate={startDate ? new Date(startDate) : null}
                                                                            endDate={endDate ? new Date(endDate) : null}
                                                                            selectsRange={true}
                                                                            inline={false}
                                                                            isClearable={false}
                                                                            dateFormat="dd/MM/yyyy"
                                                                            placeholderText={
                                                                                !startDate 
                                                                                    ? "Select start date" 
                                                                                    : !endDate 
                                                                                        ? "Select end date" 
                                                                                        : `${new Date(startDate).toLocaleDateString('en-US')} - ${new Date(endDate).toLocaleDateString('en-US')}`
                                                                            }
                                                                            minDate={new Date()}
                                                                            maxDate={new Date(Date.now() + 90 * 24 * 60 * 60 * 1000)}
                                                                            className="form-control"
                                                                            style={{
                                                                                border: 'none',
                                                                                padding: '0',
                                                                                fontSize: '14px',
                                                                                fontWeight: '500',
                                                                                backgroundColor: 'transparent',
                                                                                outline: 'none',
                                                                                boxShadow: 'none',
                                                                                color: '#2c3e50',
                                                                                cursor: 'pointer',
                                                                                width: '100%'
                                                                            }}
                                                                            calendarClassName="custom-datepicker"
                                                                            popperClassName="custom-datepicker-popper"
                                                                            wrapperClassName="custom-datepicker-wrapper"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="form-item dropdown" style={{ 
                                                            position: 'relative', 
                                                            zIndex: 9998,
                                                            width: '300px'
                                                        }}>
                                                            <div 
                                                                className="guests-container"
                                                                onClick={() => setPersonalModal(!personalModal)}
                                                            >
                                                                {/* Sol taraf - Icon */}
                                                                <div className="form-icon">
                                                                    <i className="isax isax-people" style={{ 
                                                                        color: 'rgb(30, 58, 138)', 
                                                                        fontSize: '20px' 
                                                                    }}></i>
                                                                </div>
                                                                
                                                                {/* Sağ taraf - Label ve Guest Info */}
                                                                <div style={{ 
                                                                    flex: 1,
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    gap: '4px'
                                                                }}>
                                                                    <label className="form-label" style={{
                                                                        fontWeight: '600',
                                                                        color: 'rgb(30, 58, 138)',
                                                                        fontSize: '12px',
                                                                        textTransform: 'capitalize',
                                                                        letterSpacing: '0.5px',
                                                                        margin: 0,
                                                                        lineHeight: 1
                                                                    }}>
                                                                        Guests
                                                                    </label>
                                                                    <div style={{
                                                                        display: 'flex',
                                                                        justifyContent: 'space-between',
                                                                        alignItems: 'center',
                                                                        width: '100%'
                                                                    }}>
                                                                        <span style={{ 
                                                                            fontWeight: '500', 
                                                                            color: '#2c3e50',
                                                                            fontSize: '15px'
                                                                        }}>
                                                                            {rooms?.reduce((total, room) => total + room.adultCounter + room.childCounter, 0)} Guests, {rooms?.length} Room{rooms?.length > 1 ? 's' : ''}
                                                                        </span>
                                                                        <i className="isax isax-arrow-down-1" style={{ 
                                                                            color: '#64748b', 
                                                                            fontSize: '16px',
                                                                            marginLeft: '8px'
                                                                        }}></i>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div
                                                                className="guests-dropdown"
                                                                ref={counterRef}
                                                                style={{
                                                                    display: personalModal ? "block" : "none"
                                                                }}
                                                            >
                                                                {/* Header with rooms counter */}
                                                                <div className="guests-dropdown-header">
                                                                    <div className="header-title">
                                                                        <i className="isax isax-home"></i>
                                                                        Rooms
                                                                    </div>
                                                                    <div className="guests-counter-group">
                                                                        <button
                                                                            type="button"
                                                                            onClick={() => updateRoomCount("decrement")}
                                                                            className="guests-counter-btn"
                                                                            disabled={rooms.length <= 1}
                                                                        >
                                                                            −
                                                                        </button>
                                                                        <span className="guests-counter-value">
                                                                            {rooms.length}
                                                                        </span>
                                                                        <button
                                                                            type="button"
                                                                            onClick={() => updateRoomCount("increment")}
                                                                            className="guests-counter-btn"
                                                                        >
                                                                            +
                                                                        </button>
                                                                    </div>
                                                                </div>

                                                                {/* Room details section */}
                                                                <div className="guests-rooms-section">
                                                                    {rooms.map((room, roomIndex) => (
                                                                        <div
                                                                            key={room.id}
                                                                            className="guests-room-card"
                                                                        >
                                                                            <div className="guests-room-title">
                                                                                <i className="isax isax-home-2"></i>
                                                                                Room {roomIndex + 1}
                                                                            </div>
                                                                            
                                                                            {/* Adult counter */}
                                                                            <div className="guests-counter-row">
                                                                                <div className="guests-counter-label">
                                                                                    <i className="isax isax-user"></i>
                                                                                    Adults
                                                                                </div>
                                                                                <div className="guests-counter-group">
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={() => updateRoomCounters(room.id, "adult", "decrement")}
                                                                                        className="guests-counter-btn"
                                                                                        disabled={room.adultCounter <= 1}
                                                                                    >
                                                                                        −
                                                                                    </button>
                                                                                    <span className="guests-counter-value">
                                                                                        {room.adultCounter}
                                                                                    </span>
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={() => updateRoomCounters(room.id, "adult", "increment")}
                                                                                        className="guests-counter-btn"
                                                                                    >
                                                                                        +
                                                                                    </button>
                                                                                </div>
                                                                            </div>

                                                                            {/* Children counter */}
                                                                            <div className="guests-counter-row">
                                                                                <div className="guests-counter-label">
                                                                                    <i className="isax isax-user-octagon"></i>
                                                                                    Children
                                                                                </div>
                                                                                <div className="guests-counter-group">
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={() => updateRoomCounters(room.id, "child", "decrement")}
                                                                                        className="guests-counter-btn"
                                                                                        disabled={room.childCounter <= 0}
                                                                                    >
                                                                                        −
                                                                                    </button>
                                                                                    <span className="guests-counter-value">
                                                                                        {room.childCounter}
                                                                                    </span>
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={() => updateRoomCounters(room.id, "child", "increment")}
                                                                                        className="guests-counter-btn"
                                                                                    >
                                                                                        +
                                                                                    </button>
                                                                                </div>
                                                                            </div>

                                                                            {/* Children ages */}
                                                                            {room.childCounter > 0 && (
                                                                                <div className="guests-children-ages">
                                                                                    <div className="ages-title">
                                                                                        <i className="isax isax-calendar"></i>
                                                                                        Children Ages
                                                                                    </div>
                                                                                    <div className="guests-children-ages-grid">
                                                                                        {room.childrenAges.map((child, index) => (
                                                                                            <div key={index} className="guests-child-age-item">
                                                                                                <div className="guests-child-age-label">
                                                                                                    Child {index + 1}
                                                                                                </div>
                                                                                                <input
                                                                                                    type="number"
                                                                                                    min="0"
                                                                                                    max="17"
                                                                                                    value={child.age}
                                                                                                    onChange={(e) => {
                                                                                                        const value = Math.min(17, Math.max(0, parseInt(e.target.value) || 0));
                                                                                                        handleChildAgeChange(room.id, index, value);
                                                                                                    }}
                                                                                                    className="guests-child-age-input"
                                                                                                    placeholder="Age"
                                                                                                />
                                                                                                <div className="guests-child-age-suffix">
                                                                                                    years
                                                                                                </div>
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                        <div className="form-item dropdown" style={{ 
                                                            minWidth: '280px',
                                                            position: 'relative',
                                                            zIndex: 10000
                                                        }}>
                                                            <div 
                                                                className="nationality-container"
                                                            >
                                                                {/* Sol taraf - Icon */}
                                                                <div className="form-icon">
                                                                    <i className="isax isax-flag" style={{ 
                                                                        color: 'rgb(30, 58, 138)', 
                                                                        fontSize: '20px' 
                                                                    }}></i>
                                                                </div>
                                                                
                                                                {/* Sağ taraf - Label ve Input */}
                                                                <div className="form-content">
                                                                    <label className="form-label">
                                                                        Nationality
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Search nationality"
                                                                        value={nationalityInputValue}
                                                                        onChange={handleNationalityInputChange}
                                                                        className="form-control"
                                                                        style={{
                                                                            border: 'none',
                                                                            padding: '0',
                                                                            fontSize: '15px',
                                                                            fontWeight: '500',
                                                                            backgroundColor: 'transparent',
                                                                            outline: 'none',
                                                                            boxShadow: 'none',
                                                                            color: '#2c3e50'
                                                                        }}
                                                                        onFocus={(e) => {
                                                                            e.target.style.color = '#1e3a8a';
                                                                        }}
                                                                        onBlur={(e) => {
                                                                            e.target.style.color = '#2c3e50';
                                                                        }}
                                                                    />
                                                                    
                                                                    {/* Loading ve Suggestions - Input'un altında */}
                                                                    {isNationalitySuggestLoading && (
                                                                        <div style={{
                                                                            position: 'absolute',
                                                                            top: '100%',
                                                                            left: '-16px',
                                                                            right: '-16px',
                                                                            backgroundColor: 'white',
                                                                            borderRadius: '12px',
                                                                            boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
                                                                            padding: '15px',
                                                                            textAlign: 'center',
                                                                            fontSize: '14px',
                                                                            color: '#1e3a8a',
                                                                            fontWeight: '500',
                                                                            zIndex: 99999,
                                                                            marginTop: '8px'
                                                                        }}>
                                                                            <i className="isax isax-loading spin me-2"></i>
                                                                            Searching...
                                                                        </div>
                                                                    )}
                                                                    {nationalitySuggestions.length > 0 && (
                                                                        <ul style={{ 
                                                                            width: "calc(100% + 32px)",
                                                                            position: 'absolute',
                                                                            top: '100%',
                                                                            left: '-16px',
                                                                            backgroundColor: 'white',
                                                                            borderRadius: '12px',
                                                                            boxShadow: '0 10px 40px rgba(0, 0, 0, 0.15)',
                                                                            border: 'none',
                                                                            padding: '8px 0',
                                                                            margin: '8px 0 0 0',
                                                                            zIndex: 99999,
                                                                            maxHeight: '300px',
                                                                            overflowY: 'auto',
                                                                            listStyle: 'none'
                                                                        }} className="dropdown-menu-custom">
                                                                            {nationalitySuggestions.map((suggestion, index) => (
                                                                                <li
                                                                                    key={index}
                                                                                    onClick={() => handleNationalitySuggestionClick(suggestion)}
                                                                                    className="dropdown-item-custom"
                                                                                    style={{
                                                                                        padding: '12px 18px',
                                                                                        cursor: 'pointer',
                                                                                        transition: 'all 0.2s ease',
                                                                                        borderBottom: index < nationalitySuggestions.length - 1 ? '1px solid #f5f7fa' : 'none',
                                                                                        fontSize: '14px',
                                                                                        fontWeight: '500',
                                                                                        color: '#2c3e50',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        gap: '10px'
                                                                                    }}
                                                                                    onMouseEnter={(e) => {
                                                                                        e.target.style.backgroundColor = '#f1f5f9';
                                                                                        e.target.style.color = '#1e3a8a';
                                                                                    }}
                                                                                    onMouseLeave={(e) => {
                                                                                        e.target.style.backgroundColor = 'transparent';
                                                                                        e.target.style.color = '#2c3e50';
                                                                                    }}
                                                                                >
                                                                                    <img
                                                                                        src={`https://flagcdn.com/w40/${suggestion.iso2.toLowerCase()}.png`}
                                                                                        alt={suggestion.name}
                                                                                        style={{ width: '20px', height: '15px' }}
                                                                                    />
                                                                                    {suggestion.name}
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Submit Button - Desktop'ta aynı satırda, Mobile'da alt satırda */}
                                                        {!isMobile && (
                                                            <div className="submit-btn-desktop">
                                                                <button type="submit" className="search-btn desktop">
                                                                    <i className="isax isax-search-normal"></i>
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                    
                                                    {/* Submit Button - Sadece Mobile'da alt satırda */}
                                                    {isMobile && (
                                                        <div className="submit-btn-mobile">
                                                            <div className="btn-container">
                                                                <button type="submit" className="search-btn mobile">
                                                                    <i className="isax isax-search-normal"></i>
                                                                    <span className="ms-2">Search</span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                    
                                                </div>
                                                
                                            </form>
                                        </div>
                                        
                                        <div className="tab-pane fade" id="Tour" style={{ 
                                            padding: '10px 0',
                                            borderRadius: '15px',
                                            overflow: 'visible'
                                        }}>
                                            <div className="d-flex flex-column" style={{ padding: '0px', textAlign: 'start', marginTop: '10px' }}>
                                                <span className="text-muted" style={{ fontSize: '14px', fontWeight: 'bold', textAlign: 'start', paddingInline: '15px', backgroundColor: 'white', textAlign: 'start' }}>Book Tour - Hotels, Villas, Apartments & more.</span>
                                            </div>
                                            <form onSubmit={handleTourSubmit}>
                                                <div className="d-flex flex-column">
                                                    <div className={`d-flex form-info ${isMobile ? 'mobile' : 'desktop'}`}>
                                                        <div className="form-item dropdown">
                                                            <div className="form-container">
                                                                <div className="form-icon">
                                                                    <MdOutlineModeOfTravel />
                                                                </div>
                                                                
                                                                <div className="form-content">
                                                                    <label className="form-label">
                                                                        Tour Destination
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Where do you want to go?"
                                                                        value={tourInputValue}
                                                                        onChange={handleTourInputChange}
                                                                        className="form-control form-input"
                                                                        style={{
                                                                            fontSize: '14px',
                                                                            fontWeight: '500',
                                                                            backgroundColor: '#fff',
                                                                            transition: 'all 0.3s ease',
                                                                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
                                                                        }}
                                                                    />
                                                                    
                                                                    {isTourSuggestLoading && (
                                                                        <div className="loading-container">
                                                                            <i className="isax isax-loading spin me-2"></i>
                                                                            Searching tours...
                                                                        </div>
                                                                    )}
                                                                    {tourSuggestions.length > 0 && (
                                                                        <ul className="dropdown-menu-custom">
                                                                            {tourSuggestions.map((suggestion, index) => (
                                                                                <li
                                                                                    key={index}
                                                                                    onClick={() => handleTourSuggestionClick(suggestion)}
                                                                                    className="dropdown-item-custom"
                                                                                >
                                                                                    <span style={{ color: '#1e3a8a', fontSize: '16px' }}>
                                                                                        🎯
                                                                                    </span>
                                                                                    {suggestion.name}
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="form-item dropdown" ref={monthDropdownRef} style={{ 
                                                            position: 'relative', 
                                                            zIndex: 9996 
                                                        }}>
                                                            <div className="form-container">
                                                                <div className="form-icon">
                                                                    <IoCalendarNumberSharp />
                                                                </div>
                                                                
                                                                <div className="form-content">
                                                                    <label className="form-label">
                                                                        Travel Months
                                                                    </label>
                                                                    <div 
                                                                        className="form-control" 
                                                                        style={{ 
                                                                            minWidth: '200px', 
                                                                            cursor: 'pointer', 
                                                                            position: 'relative',
                                                                            border: 'none',
                                                                            padding: '0',
                                                                            fontSize: '15px',
                                                                            fontWeight: '500',
                                                                            backgroundColor: 'transparent',
                                                                            outline: 'none',
                                                                            boxShadow: 'none',
                                                                            color: '#2c3e50',
                                                                            width: '100%'
                                                                        }}
                                                                        onClick={() => setMonthDropdownOpen(!monthDropdownOpen)}
                                                                    >
                                                                        <span className={selectedMonths.length > 0 ? 'text-dark' : 'text-muted'}>
                                                                            {selectedMonths.length > 0 
                                                                                ? `${selectedMonths.length} month${selectedMonths.length > 1 ? 's' : ''} selected`
                                                                                : 'Select months'
                                                                            }
                                                                        </span>
                                                                        <i className="fas fa-chevron-down" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}></i>
                                                                    </div>
                                                                    
                                                                    {monthDropdownOpen && (
                                                                        <div 
                                                                            className="dropdown-menu-custom"
                                                                            style={{
                                                                                position: 'absolute',
                                                                                top: '100%',
                                                                                left: '0',
                                                                                right: '0',
                                                                                backgroundColor: 'white',
                                                                                border: '1px solid #dee2e6',
                                                                                borderRadius: '8px',
                                                                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                                                                zIndex: 99996,
                                                                                maxHeight: '200px',
                                                                                overflowY: 'auto',
                                                                                marginTop: '5px'
                                                                            }}
                                                                        >
                                                                            {availableMonths.map(month => (
                                                                                <div
                                                                                    key={month.value}
                                                                                    className={`dropdown-item-custom ${selectedMonths.includes(month.value) ? 'selected' : ''}`}
                                                                                    onClick={() => handleMonthToggle(month.value)}
                                                                                    style={{
                                                                                        padding: '10px 15px',
                                                                                        cursor: 'pointer',
                                                                                        borderBottom: '1px solid #f0f0f0',
                                                                                        backgroundColor: selectedMonths.includes(month.value) ? '#f8f9fa' : 'white',
                                                                                        display: 'flex',
                                                                                        justifyContent: 'space-between',
                                                                                        alignItems: 'center'
                                                                                    }}
                                                                                >
                                                                                    <span>{month.name} {month.year}</span>
                                                                                    {selectedMonths.includes(month.value) && (
                                                                                        <i className="fas fa-check text-success"></i>
                                                                                    )}
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="form-item dropdown">
                                                            <div className="form-container">
                                                                <div className="form-icon">
                                                                    <i className="isax isax-clock"></i>
                                                                </div>
                                                                
                                                                <div className="form-content">
                                                                    <label className="form-label">
                                                                        Duration
                                                                    </label>
                                                                    <div style={{ position: 'relative' }}>
                                                                        <select 
                                                                            className="form-control" 
                                                                            style={{ 
                                                                                minWidth: '150px',
                                                                                border: 'none',
                                                                                padding: '0',
                                                                                fontSize: '15px',
                                                                                fontWeight: '500',
                                                                                backgroundColor: 'transparent',
                                                                                outline: 'none',
                                                                                boxShadow: 'none',
                                                                                color: '#2c3e50',
                                                                                appearance: 'none',
                                                                                cursor: 'pointer',
                                                                                paddingRight: '50px',
                                                                                width: '100%'
                                                                            }}
                                                                            value={tourDuration}
                                                                            onChange={(e) => setTourDuration(e.target.value)}
                                                                            disabled={durationsLoading}
                                                                        >
                                                                            <option value="">
                                                                                {durationsLoading ? 'Loading...' : 'Select duration'}
                                                                            </option>
                                                                            {tourDurations.map((duration) => (
                                                                                <option key={duration.slug} value={duration.slug}>
                                                                                    {duration.name}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                        <i className="fas fa-chevron-down" style={{ 
                                                                            position: 'absolute', 
                                                                            right: '15px', 
                                                                            top: '50%', 
                                                                            transform: 'translateY(-50%)',
                                                                            color: '#64748b',
                                                                            pointerEvents: 'none'
                                                                        }}></i>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="form-item dropdown" ref={tourTypesDropdownRef} style={{ 
                                                            position: 'relative',
                                                            minWidth: '200px',
                                                            zIndex: 9995
                                                        }}>
                                                            <div className="form-container">
                                                                <div className="form-icon">
                                                                    <i className="isax isax-category"></i>
                                                                </div>
                                                                
                                                                <div className="form-content">
                                                                    <label className="form-label">
                                                                        Tour Types
                                                                    </label>
                                                                    
                                                                    <div 
                                                                        className="form-control" 
                                                                        style={{ 
                                                                            minWidth: '200px', 
                                                                            cursor: 'pointer', 
                                                                            position: 'relative',
                                                                            border: 'none',
                                                                            padding: '0',
                                                                            fontSize: '15px',
                                                                            fontWeight: '500',
                                                                            backgroundColor: 'transparent',
                                                                            outline: 'none',
                                                                            boxShadow: 'none',
                                                                            color: '#2c3e50',
                                                                            width: '100%'
                                                                        }}
                                                                        onClick={() => setTourTypesDropdownOpen(!tourTypesDropdownOpen)}
                                                                    >
                                                                        <span className={selectedTourTypes.length > 0 ? 'text-dark' : 'text-muted'}>
                                                                            {tourTypesLoading ? 'Loading...' : 
                                                                                selectedTourTypes.length > 0 
                                                                                    ? selectedTourTypes.length === 1 
                                                                                        ? selectedTourTypes[0].name
                                                                                        : `${selectedTourTypes.length} types selected`
                                                                                    : 'Select tour types'
                                                                            }
                                                                        </span>
                                                                        <i className="fas fa-chevron-down" style={{ position: 'absolute', right: '15px', top: '50%', transform: 'translateY(-50%)' }}></i>
                                                                    </div>
                                                                    
                                                                    {tourTypesDropdownOpen && tourTypes.length > 0 && (
                                                                        <div 
                                                                            className="dropdown-menu-custom"
                                                                            style={{
                                                                                position: 'absolute',
                                                                                top: '100%',
                                                                                left: '0',
                                                                                right: '0',
                                                                                backgroundColor: 'white',
                                                                                border: '1px solid #dee2e6',
                                                                                borderRadius: '8px',
                                                                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                                                                zIndex: 99995,
                                                                                maxHeight: '200px',
                                                                                overflowY: 'auto',
                                                                                marginTop: '5px'
                                                                            }}
                                                                        >
                                                                            {tourTypes.map(type => (
                                                                                <div
                                                                                    key={type.slug}
                                                                                    className={`dropdown-item-custom ${selectedTourTypes.some(selected => selected.id === type.id) ? 'selected' : ''}`}
                                                                                    onClick={() => handleTourTypeToggle(type)}
                                                                                    style={{
                                                                                        padding: '10px 15px',
                                                                                        cursor: 'pointer',
                                                                                        borderBottom: '1px solid #f0f0f0',
                                                                                        backgroundColor: selectedTourTypes.some(selected => selected.id === type.id) ? '#f8f9fa' : 'white',
                                                                                        display: 'flex',
                                                                                        justifyContent: 'space-between',
                                                                                        alignItems: 'center'
                                                                                    }}
                                                                                >
                                                                                    <span>{type.name}</span>
                                                                                    {selectedTourTypes.some(selected => selected.id === type.id) && (
                                                                                        <i className="fas fa-check text-success"></i>
                                                                                    )}
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                        {/* Submit Button - Desktop'ta aynı satırda, Mobile'da alt satırda */}
                                                        {!isMobile && (
                                                            <div className="" style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                flexShrink: 0,
                                                                width: '80px',
                                                                height: '80px',
                                                                marginBlock: '10px'
                                                            }}>
                                                                <button type="submit"
                                                                    className="btn btn-dark rounded"
                                                                    style={{
                                                                        backgroundColor: 'rgb(30, 58, 138)',
                                                                        border: 'none',
                                                                        borderRadius: '25px',
                                                                        color: 'white',
                                                                        boxShadow: '0 6px 20px rgba(30, 58, 138, 0.3)',
                                                                        transition: 'all 0.3s ease',
                                                                        display: 'flex',
                                                                        width: '80px',
                                                                        height: '80px',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        fontWeight: '600'
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        e.target.style.transform = 'translateY(-2px)';
                                                                        e.target.style.boxShadow = '0 10px 30px rgba(30, 58, 138, 0.4)';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.target.style.transform = 'translateY(0)';
                                                                        e.target.style.boxShadow = '0 6px 20px rgba(30, 58, 138, 0.3)';
                                                                    }}>
                                                                    <i className="isax isax-camera5" style={{ 
                                                                        fontSize: '24px', 
                                                                        fontWeight: '600' 
                                                                    }}></i>
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                    
                                                    {/* Submit Button - Sadece Mobile'da alt satırda */}
                                                    {isMobile && (
                                                        <div className="submit-btn-mobile">
                                                            <div className="btn-container">
                                                                <button type="submit"
                                                                    className="btn btn-dark search-btn mobile"
                                                                    onMouseEnter={(e) => {
                                                                        e.target.style.transform = 'translateY(-2px)';
                                                                        e.target.style.boxShadow = '0 10px 30px rgba(30, 58, 138, 0.4)';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.target.style.transform = 'translateY(0)';
                                                                        e.target.style.boxShadow = '0 6px 20px rgba(30, 58, 138, 0.3)';
                                                                    }}>
                                                                    <i className="isax isax-camera5"></i>
                                                                    <span className="ms-2">Search Tours</span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </form>
                                        </div>
                                        
                                        <div className="tab-pane fade" id="Transfer" style={{ 
                                            padding: '10px 0',
                                            borderRadius: '15px',
                                            overflow: 'visible'
                                        }}>
                                            <form onSubmit={handleTransferSubmit}>
                                            <div className="d-flex flex-column" style={{ padding: '0px', textAlign: 'start', marginTop: '10px' }}>
                                                <div className="transfer-type-row">
                                                    <div className={`transfer-type-option ${transferType === 'one-way' ? 'active' : ''}`}>
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="transferType"
                                                            id="oneWay"
                                                            value="one-way"
                                                            checked={transferType === 'one-way'}
                                                            onChange={(e) => setTransferType(e.target.value)}
                                                        />
                                                        <label className="form-check-label fw-medium" htmlFor="oneWay">
                                                            <i className="isax isax-arrow-right me-1" style={{ fontSize: '12px' }}></i>One Way
                                                        </label>
                                                    </div>
                                                    <div className={`transfer-type-option ${transferType === 'round-trip' ? 'active' : ''}`}>
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="transferType"
                                                            id="roundTrip"
                                                            value="round-trip"
                                                            checked={transferType === 'round-trip'}
                                                            onChange={(e) => setTransferType(e.target.value)}
                                                        />
                                                        <label className="form-check-label fw-medium" htmlFor="roundTrip">
                                                            <i className="isax isax-arrow-swap-horizontal me-1" style={{ fontSize: '12px' }}></i>Round Trip
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                                <div className="d-flex flex-column">
                                                    {/* Transfer Type Selection - Üst satırda */}
                                                    
                                                    {/* Ana form inputları */}
                                                    <div className={`d-flex form-info ${isMobile ? 'mobile' : 'desktop'}`}>

                                                        {/* Pickup Location */}
                                                        <div className="form-item dropdown transfer-location-item">
                                                            <div className="form-container">
                                                                <div className="form-icon">
                                                                    <i className="isax isax-location"></i>
                                                                </div>
                                                                
                                                                <div className="form-content">
                                                                    <label className="form-label">
                                                                        Pickup Location
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        placeholder="From where?"
                                                                        value={transferPickupInput}
                                                                        onChange={handleTransferPickupInputChange}
                                                                        className="form-control"
                                                                        style={{
                                                                            fontSize: '14px',
                                                                            fontWeight: '500',
                                                                            backgroundColor: '#fff',
                                                                            transition: 'all 0.3s ease',
                                                                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
                                                                        }}
                                                                    />
                                                                    
                                                                    {isTransferPickupLoading && (
                                                                        <div className="loading-container">
                                                                            <i className="isax isax-loading spin me-2"></i>
                                                                            Searching...
                                                                        </div>
                                                                    )}
                                                                    {transferPickupSuggestions.length > 0 && (
                                                                        <ul className="dropdown-menu-custom">
                                                                            {transferPickupSuggestions.map((suggestion, index) => (
                                                                                <li
                                                                                    key={index}
                                                                                    onClick={() => handleTransferPickupSuggestionClick(suggestion)}
                                                                                    className="dropdown-item-custom"
                                                                                >
                                                                                    <span style={{ color: '#1e3a8a', fontSize: '16px' }}>
                                                                                        {getIcon(suggestion.type)}
                                                                                    </span>
                                                                                    {suggestion.name}
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Dropoff Location */}
                                                        <div className="form-item dropdown transfer-location-item">
                                                            <div className="form-container">
                                                                <div className="form-icon">
                                                                    <i className="isax isax-location"></i>
                                                                </div>
                                                                
                                                                <div className="form-content">
                                                                    <label className="form-label">
                                                                        Dropoff Location
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        placeholder="To where?"
                                                                        value={transferDropoffInput}
                                                                        onChange={handleTransferDropoffInputChange}
                                                                        className="form-control"
                                                                        style={{
                                                                            fontSize: '14px',
                                                                            fontWeight: '500',
                                                                            backgroundColor: '#fff',
                                                                            transition: 'all 0.3s ease',
                                                                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
                                                                        }}
                                                                    />
                                                                    
                                                                    {isTransferDropoffLoading && (
                                                                        <div className="loading-container">
                                                                            <i className="isax isax-loading spin me-2"></i>
                                                                            Searching...
                                                                        </div>
                                                                    )}
                                                                    {transferDropoffSuggestions.length > 0 && (
                                                                        <ul className="dropdown-menu-custom">
                                                                            {transferDropoffSuggestions.map((suggestion, index) => (
                                                                                <li
                                                                                    key={index}
                                                                                    onClick={() => handleTransferDropoffSuggestionClick(suggestion)}
                                                                                    className="dropdown-item-custom"
                                                                                >
                                                                                    <span style={{ color: '#1e3a8a', fontSize: '16px' }}>
                                                                                        {getIcon(suggestion.type)}
                                                                                    </span>
                                                                                    {suggestion.name}
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Transfer Date - Kompakt */}
                                                        <div className="form-item" style={{ minWidth: transferType === 'round-trip' ? '200px' : '160px' }}>
                                                            <div className="form-container">
                                                                <div className="form-icon">
                                                                    <i className="isax isax-calendar"></i>
                                                                </div>
                                                                
                                                                <div className="form-content">
                                                                    <label className="form-label">
                                                                        {transferType === 'one-way' ? 'Transfer Date' : 'Departure'}
                                                                    </label>
                                                                    <input 
                                                                        type="date"
                                                                        className="transfer-date-input"
                                                                        value={transferDate}
                                                                        min={new Date().toISOString().split('T')[0]}
                                                                        onChange={(e) => {
                                                                            const newDate = e.target.value;
                                                                            setTransferDate(newDate);
                                                                            // Round trip ise return date'i otomatik ayarla
                                                                            if (transferType === 'round-trip') {
                                                                                const nextDay = new Date(newDate);
                                                                                nextDay.setDate(nextDay.getDate() + 1);
                                                                                setReturnDate(nextDay.toISOString().split('T')[0]);
                                                                            }
                                                                        }}
                                                                        onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Return Date - only show for round trip - Kompakt */}
                                                        {transferType === 'round-trip' && (
                                                            <div className="form-item" style={{ minWidth: '160px' }}>
                                                                <div className="form-container">
                                                                    <div className="form-icon">
                                                                        <i className="isax isax-calendar"></i>
                                                                    </div>
                                                                    
                                                                    <div className="form-content">
                                                                        <label className="form-label">
                                                                            Return
                                                                        </label>
                                                                        <input 
                                                                            type="date"
                                                                            className="transfer-date-input"
                                                                            value={returnDate}
                                                                            min={transferDate || new Date().toISOString().split('T')[0]}
                                                                            onChange={(e) => setReturnDate(e.target.value)}
                                                                            onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* Passengers - Modern Dropdown */}
                                                        <div className="form-item dropdown" style={{ 
                                                            minWidth: '160px',
                                                            position: 'relative',
                                                            zIndex: 9997
                                                        }}>
                                                            <div className="form-container">
                                                                <div className="form-icon">
                                                                    <i className="isax isax-profile-2user"></i>
                                                                </div>
                                                                
                                                                <div className="form-content">
                                                                    <label className="form-label">
                                                                        Passengers
                                                                    </label>
                                                                    <div 
                                                                        className="form-control"
                                                                        onClick={() => setTransferPassengersModal(!transferPassengersModal)}
                                                                        style={{
                                                                            border: 'none',
                                                                            padding: '0',
                                                                            fontSize: '14px',
                                                                            fontWeight: '500',
                                                                            backgroundColor: 'transparent',
                                                                            outline: 'none',
                                                                            boxShadow: 'none',
                                                                            color: '#2c3e50',
                                                                            cursor: 'pointer',
                                                                            width: '100%',
                                                                            display: 'flex',
                                                                            justifyContent: 'space-between',
                                                                            alignItems: 'center'
                                                                        }}
                                                                    >
                                                                        <span>
                                                                            {transferAdults + transferChildren} Passengers
                                                                        </span>
                                                                        <i className="isax isax-arrow-down-1" style={{ 
                                                                            color: '#64748b', 
                                                                            fontSize: '14px' 
                                                                        }}></i>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div
                                                                className="transfer-passengers-dropdown"
                                                                ref={transferPassengersRef}
                                                                style={{
                                                                    display: transferPassengersModal ? "block" : "none"
                                                                }}
                                                            >
                                                                {/* Header */}
                                                                <div className="transfer-passengers-header">
                                                                    <div className="header-title">
                                                                        <i className="isax isax-profile-2user"></i>
                                                                        Passengers
                                                                    </div>
                                                                </div>

                                                                {/* Passengers section */}
                                                                <div className="transfer-passengers-section">
                                                                    {/* Adults */}
                                                                    <div className="transfer-passenger-row">
                                                                        <div className="transfer-passenger-label">
                                                                            <i className="isax isax-user"></i>
                                                                            Adults
                                                                        </div>
                                                                        <div className="transfer-passenger-counter">
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => setTransferAdults(Math.max(1, transferAdults - 1))}
                                                                                className="transfer-passenger-btn"
                                                                                disabled={transferAdults <= 1}
                                                                            >
                                                                                −
                                                                            </button>
                                                                            <span className="transfer-passenger-count">
                                                                                {transferAdults}
                                                                            </span>
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => setTransferAdults(transferAdults + 1)}
                                                                                className="transfer-passenger-btn"
                                                                            >
                                                                                +
                                                                            </button>
                                                                        </div>
                                                                    </div>

                                                                    {/* Children */}
                                                                    <div className="transfer-passenger-row">
                                                                        <div className="transfer-passenger-label">
                                                                            <i className="isax isax-user-octagon"></i>
                                                                            Children
                                                                        </div>
                                                                        <div className="transfer-passenger-counter">
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => setTransferChildren(Math.max(0, transferChildren - 1))}
                                                                                className="transfer-passenger-btn"
                                                                                disabled={transferChildren <= 0}
                                                                            >
                                                                                −
                                                                            </button>
                                                                            <span className="transfer-passenger-count">
                                                                                {transferChildren}
                                                                            </span>
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => setTransferChildren(transferChildren + 1)}
                                                                                className="transfer-passenger-btn"
                                                                            >
                                                                                +
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                        {/* Submit Button - Desktop'ta aynı satırda, Mobile'da alt satırda */}
                                                        {!isMobile && (
                                                            <div className="submit-btn-desktop">
                                                                <button type="submit" className="search-btn desktop">
                                                                    <i className="isax isax-search-normal"></i>
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                    
                                                    {/* Submit Button - Sadece Mobile'da alt satırda */}
                                                    {isMobile && (
                                                        <div className="submit-btn-mobile">
                                                            <div className="btn-container">
                                                                <button type="submit" className="search-btn mobile">
                                                                    <i className="isax isax-search-normal"></i>
                                                                    <span className="ms-2">Search Transfers</span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
)
}
